<div class="mat-elevation-z4 section-container">
    <div class="title-bar-top">
        <button mat-flat-button color="primary" (click)="refresh()">FRISSÍTÉS</button>
    </div>
    <div class="title-bar">

        <div class="title-bar__right">
            <form class="payment-request-form" [formGroup]="formControl">
                <mat-form-field class="left">
                    <mat-label>Szűrés létrehozás dátuma alapján</mat-label>
                    <input matInput formControlName="creationDate" [matDatepicker]="picker">
                    <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
                    <mat-datepicker #picker></mat-datepicker>
                </mat-form-field>
                <mat-form-field class="center">
                    <mat-label>Szűrés fizető fél neve alapján</mat-label>
                    <input matInput formControlName="payerName" placeholder="Fizető fél neve (substring)">
                </mat-form-field>
                <mat-form-field class="right">
                    <mat-label>Szűrés közlemény alapján</mat-label>
                    <input matInput formControlName="comment" placeholder="Közlemény (substring)">
                </mat-form-field>
            </form>
        </div>
    </div>

    <div class="table-container">
        <table mat-table [dataSource]="dataSource" matSort>
            <ng-container matColumnDef="creationDateTime">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Létrehozás dátuma</th>
                <td mat-cell *matCellDef="let row">{{row.creationDateTime | date: 'yyyy.MM.dd. HH:mm:ss' }}</td>
            </ng-container>

            <ng-container matColumnDef="type">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Típus</th>
                <td mat-cell *matCellDef="let row">
                    <span *ngIf="row.type === 'PAYMENT_REQUEST_UNATTENDED';">Fizető fél részvétele nélkül</span>
                    <span *ngIf="row.type === 'PAYMENT_REQUEST_PAYER_ATTENDED';">Fizető fél részvételével</span>
                </td>
            </ng-container>

            <ng-container matColumnDef="payer">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Fizető fél</th>
                <td mat-cell *matCellDef="let row">
                    <span *ngIf="row.type === 'PAYMENT_REQUEST_UNATTENDED';">{{row.payer.name}}</span>
                    <span *ngIf="row.type === 'PAYMENT_REQUEST_PAYER_ATTENDED';">{{row.payer.emailAddress}}</span>
                </td>
            </ng-container>

            <ng-container matColumnDef="amount">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Összeg</th>
                <td mat-cell *matCellDef="let row">{{row.amount}}
                </td>
            </ng-container>

            <ng-container matColumnDef="comment">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Közlemény</th>
                <td mat-cell *matCellDef="let row">{{row.comment}}
                </td>
            </ng-container>

            <ng-container matColumnDef="status">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Státusz</th>
                <td mat-cell *matCellDef="let row">{{row.status}}
                </td>
            </ng-container>

            <ng-container matColumnDef="details" stickyEnd>
                <th mat-header-cell *matHeaderCellDef aria-label="row details">&nbsp;</th>
                <td mat-cell *matCellDef="let row" (click)="$event.stopPropagation()">
                    <button mat-flat-button color="primary" (click)="openDetailsDialog(row)">RÉSZLETEK</button>
                </td>
            </ng-container>

            <ng-container matColumnDef="recall" stickyEnd>
                <th mat-header-cell *matHeaderCellDef aria-label="row recall">&nbsp;</th>
                <td mat-cell *matCellDef="let row" (click)="$event.stopPropagation()">
                    <button class="recall-button" *ngIf="row.recallStatus === 'RECALLABLE'" mat-flat-button
                        color="primary" disabled="false" (click)="openRecallDialog(row)"
                        matTooltip="Visszahívás előtt frissítse a listát!" matTooltipClass="recall-tooltip">
                        VISSZAHÍVÁS
                    </button>
                    <button class="recall-button recall-in-progress"
                        *ngIf="row.recallStatus === 'RECALL_IS_IN_PROGRESS'" mat-flat-button disabled="true"
                        (click)="openRecallDialog(row)">
                        VISSZAHÍVÁS FOLYAMATBAN
                    </button>
                    <button class="recall-button waiting-for-giro" *ngIf="row.recallStatus === 'WAITING_FOR_GIRO'"
                        mat-flat-button color="primary" disabled="true" (click)="openRecallDialog(row)">
                        VÁRAKOZÁS A GIRORA
                    </button>
                    <button class="recall-button" *ngIf="row.recallStatus === 'NON_RECALLABLE'" mat-flat-button
                        color="primary" disabled="true" (click)="openRecallDialog(row)">
                        NEM VISSZAHÍVHATÓ
                    </button>
                </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>

        @if (isLoading) {
        <progress-spinner></progress-spinner>
        }
    </div>

    <mat-paginator showFirstLastButtons [pageSizeOptions]="[5, 10, 20]" [pageSize]="20"
        aria-label="Select page of payment requests"></mat-paginator>
</div>
